import React, { useState } from 'react';
import { Button } from '@heroui/react';
import { Input } from 'src/shared/components/Input';
import { Eye, EyeOff } from 'lucide-react';

const ResetPassword = ({ loading, isButtonDisabled, onSubmit, token }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [errors, setErrors] = useState({ password: '', confirmPassword: '' });

  const toggleVisibility = () => setIsVisible(!isVisible);

  const hasErrors = () => {
    let newErrors = { password: '', confirmPassword: '' };
    let hasError = false;

    if (!password.trim()) {
      newErrors.password = 'Password is required';
      hasError = true;
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
      hasError = true;
    }

    if (confirmPassword !== password) {
      newErrors.confirmPassword = 'Passwords do not match';
      hasError = true;
    }

    setErrors(newErrors);
    return hasError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (hasErrors()) return;
    onSubmit(password, token);
  };

  return (
    <div className="form-container" id="reset-password-form">
      <h1 className="h2 text-center">Reset Password</h1>
      <form className="flex flex-col gap-2 mt-10" onSubmit={handleSubmit}>
        <Input
          label="New Password"
          name="password"
          value={password}
          onValueChange={(val) => {
            setPassword(val);
            setErrors((prev) => ({ ...prev, password: '' }));
          }}
          isInvalid={!!errors.password}
          errorMessage={errors.password}
          endContent={
            <button
              className="focus:outline-none"
              type="button"
              onClick={toggleVisibility}
              aria-label="toggle password visibility"
            >
              {isVisible ? (
                <Eye size={16} className="text-lg text-default-400 pointer-events-none" />
              ) : (
                <EyeOff size={16} className="text-lg text-default-400 pointer-events-none" />
              )}
            </button>
          }
          type={isVisible ? 'text' : 'password'}
        />
        <Input
          label="Confirm Password"
          name="confirmPassword"
          value={confirmPassword}
          onValueChange={(val) => {
            setConfirmPassword(val);
            setErrors((prev) => ({ ...prev, confirmPassword: '' }));
          }}
          isInvalid={!!errors.confirmPassword}
          errorMessage={errors.confirmPassword}
          type="password"
        />
        <div className="mt-3">
          {loading ? (
            <Button className="bg-[#007CA1] text-white w-full" disabled>
              Saving...
            </Button>
          ) : (
            <Button type="submit" className="bg-[#007CA1] text-white w-full" style={isButtonDisabled ? {opacity: 0.8} : {opacity: 1}} disabled={isButtonDisabled}>
              Reset Password
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;